import L from "leaflet"

const MARKER_KINDS = ["stop", "venue", "location"]

const ROUTE_STYLES = {
  gpx: {
    color: "#1d4ed8",
    opacity: 0.9,
    weight: 5
  },
  routing: {
    color: "#059669",
    opacity: 0.95,
    weight: 5
  },
  straight_line: {
    color: "#0f766e",
    dashArray: "8 8",
    opacity: 0.8,
    weight: 4
  }
}

export function routeStyleFor(source) {
  return ROUTE_STYLES[source] || ROUTE_STYLES.straight_line
}

export function markerIconFor(marker) {
  const kind = normalizedMarkerKind(marker.kind)
  const position = escapeHtml(String(marker.position || ""))

  return L.divIcon({
    className: "",
    html: `<span class="route-map-marker route-map-marker--${kind}">${position}</span>`,
    iconAnchor: [18, 18],
    iconSize: [36, 36]
  })
}

export function markerTooltipFor(marker) {
  const position = escapeHtml(String(marker.position || ""))
  const name = escapeHtml(String(marker.name || ""))

  return `${position}. ${name}`.trim()
}

export function infoMarkup(message, tone = "slate") {
  const toneClasses = tone === "amber"
    ? "border-amber-200 bg-amber-50 text-amber-900"
    : "border-slate-200 bg-slate-50 text-slate-900"

  return `<p class="rounded-lg border px-4 py-3 text-sm ${toneClasses}">${escapeHtml(message)}</p>`
}

export function formatCoordinate(value) {
  return value == null ? "—" : Number(value).toFixed(5)
}

export function escapeHtml(value) {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;")
}

function normalizedMarkerKind(kind) {
  return MARKER_KINDS.includes(kind) ? kind : "location"
}